module.exports = __webpack_public_path__ + "static/post-a138038d2f324ce9271c23f14ed49b0d.png";